import { HStack, Select, Text } from "@chakra-ui/react";
import { useShipmentFacets } from "../hooks/useShipmentFacets";
import { useEffect } from "react";
import { DispatchMode } from "../../../types";
import { CityScope, ShipmentFilters, SortOrder } from "../types";

export interface ShipmentFiltersProps {
  statusFilter: "undelivered" | "delivered" | "cancelled";
  isApiConfigReady: boolean;
  filters: ShipmentFilters;
  onFiltersChange: (filters: ShipmentFilters) => void;
}

export default function ShipmentFiltersBar({
  statusFilter,
  isApiConfigReady,
  filters,
  onFiltersChange,
}: ShipmentFiltersProps) {
  const { shipmentModes, loading } = useShipmentFacets(
    statusFilter,
    isApiConfigReady
  );

  useEffect(() => {
    if (
      !loading &&
      shipmentModes.length > 0 &&
      filters.dispatchMode !== undefined
    ) {
      const availableModes = new Set(
        shipmentModes.map((item) => (item.mode === null ? null : item.mode))
      );
      const isInvalidMode = !availableModes.has(filters.dispatchMode);

      if (isInvalidMode) {
        const { dispatchMode: _removed, ...restFilters } = filters;
        onFiltersChange(restFilters);
      }
    }
  }, [loading, shipmentModes]);

  return (
    <HStack spacing={4} align="center" flexWrap="nowrap">
      <HStack spacing={2} align="center" flexWrap="nowrap">
        <Text
          fontSize="sm"
          fontWeight="500"
          color="gray.800"
          whiteSpace="nowrap"
        >
          Dispatch Mode:
        </Text>
        <Select
          placeholder="All Modes"
          value={
            filters.dispatchMode === null
              ? "__NULL__"
              : filters.dispatchMode || ""
          }
          onChange={(e) => {
            const value = e.target.value;
            if (value === "" || value === "__ALL__") {
              const { dispatchMode: _removed, ...restFilters } = filters;
              onFiltersChange(restFilters);
            } else if (value === "__NULL__") {
              onFiltersChange({
                ...filters,
                dispatchMode: null,
              });
            } else {
              onFiltersChange({
                ...filters,
                dispatchMode: value,
              });
            }
          }}
          size="sm"
          bg="white"
          isDisabled={loading}
          minW="160px"
          borderRadius="md"
          cursor="pointer"
        >
          {shipmentModes.map((item) => {
            const modeValue = item.mode === null ? "__NULL__" : item.mode;
            const modeLabel =
              item.mode === null ? DispatchMode.UNKNOWN : item.mode;
            return (
              <option key={modeValue} value={modeValue}>
                {modeLabel}
              </option>
            );
          })}
        </Select>
      </HStack>
    </HStack>
  );
}

export type { CityScope, SortOrder };
